import React from "react";
import { Box } from "@mui/material";
import useTopScrollbar from "hooks/useTopScrollbar";

export default function TableWithTopScroll({ children, deps = [], sx = {} }) {
  const { containerRef, topScrollRef, topInnerRef, isDragging } =
    useTopScrollbar(deps);

  return (
    <Box sx={{ position: "relative", ...sx }}>
      {/* Top scrollbar - sticky at top of the table wrapper */}
      <Box
        ref={topScrollRef}
        sx={{
          overflowX: "auto",
          overflowY: "hidden",
          height: 16,
          cursor: isDragging ? "grabbing" : "grab",
          userSelect: isDragging ? "none" : "auto",
          "&::-webkit-scrollbar": { height: 10 },
          "&::-webkit-scrollbar-track": {
            background: "#f1f5f9",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#f59e0b",
            borderRadius: "8px",
            "&:hover": { background: "#d97706" },
          },
          position: "sticky",
          top: 0,
          zIndex: 5,
          mb: 0.5,
        }}
      >
        <Box ref={topInnerRef} sx={{ height: 1 }} />
      </Box>

      {/* Actual table container — hide its OWN horizontal scrollbar since top one is the driver */}
      <Box
        ref={containerRef}
        sx={{
          overflowX: "auto",
          overflowY: "hidden",
          cursor: isDragging ? "grabbing" : "grab", // 👈 the hand cursor
          userSelect: isDragging ? "none" : "auto",
          touchAction: "pan-y", // horizontal drag, vertical page scroll
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
